import { Fragment } from 'react';
// Contexts
import { usePageEpisodesContext } from 'app/context/PageEpisodes.context'
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Async
import { deleteEpisodes } from 'app/store/Episodes/Episodes.async';
// Actions
import PageActions from 'app/store/page/page.actions';
// Selectors
import { selectLoading } from 'app/store/Episodes/Episodes.selectors';
import { selectPage } from 'app/store/page/page.selectors';
// Mui
import { Tooltip } from '@mui/material';
// Icons
import { Delete as DeleteIcon } from '@mui/icons-material';
// Components
import { IconButton } from 'app/components/Mui';
// Dialogs
import ConfirmationDialog from 'app/dialogs/ConfirmationDialog';
// Hooks
import useToggle from 'app/hooks/useToggle';
import useAccountStatus from 'app/hooks/useAccountStatus';
// Services
import { generateWorkspaceOrder } from 'app/store/page/page.service';

const DeleteAllEpisodesButton = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const page = useAppSelector(selectPage);
  const loading = useAppSelector(selectLoading);

  const { isSuspended } = useAccountStatus();

  const { episodes, onDelete } = usePageEpisodesContext();

  const { open, toggle } = useToggle();

  const handleConfirm = async () => {
    const episodeIds = episodes.map((episode) => episode.id);

    if ( page.parentEpisodeId ) await asyncPatchPage(null, undefined, undefined);

    await dispatch(deleteEpisodes({ episodeIds, message: 'All episodes deleted' })).unwrap();

    for ( let id of episodeIds ) {
      onDelete(id);
    }

    if ( open ) toggle();
  }

   // ToDO
   const asyncPatchPage = async (parentEpisodeId:number | null, date:string | undefined, time:string | undefined) => {
    // Patch page
    const nextPageData:any = {
      version: page.version,
      parentEpisodeId
    };
    if ( page.inWorkspace ){
      nextPageData['workspaceOrder'] = generateWorkspaceOrder(null, {
        workspaceOrder: page.workspaceOrder,
        date,
        time
      });
    }
    return new Promise((resolve) => {
      dispatch(PageActions.patchPage(page.documentId, page.pageNum, nextPageData));
      setTimeout(() => {
        resolve(`Page updated`)
      }, 500);
    });
  }

  if ( !episodes.length ) return null;
  return (
    <Fragment>
      <Tooltip title="Delete all episodes">
        <IconButton
          name="Delete all episodes"
          onClick={toggle}
          color="error"
          size="small"
          disabled={isSuspended}
        ><DeleteIcon /></IconButton>
      </Tooltip>
      {open ? (
        <ConfirmationDialog
          open={open}
          onClose={toggle}
          onConfirm={handleConfirm}
          loading={loading}
          title="Delete all episodes"
          content="Are you sure you want to delete all episodes?"
        />
      ) : null}
    </Fragment>
  )
}

export default DeleteAllEpisodesButton;
